import { MatchStatus } from '../utils/statsperform/types'
import { isDev } from './const'

const outletKey = 'jfenk1qhmxz917eqm86gi4ecz'
const baseUrl = isDev
    ? 'http://localhost:3000/handballdata'
    : 'https://api.performfeeds.com/handballdata'
const rt = isDev ? 'b' : 'c'

export const API_URL = {
    matchDetails: (matchId: string) =>
        `${baseUrl}/match/${outletKey}/${matchId}?_rt=${rt}&_fmt=json&live=yes&lineups=yes`,
    matchsList: (tournamentCalendarId: string, page: number, limit: number) =>
        `${baseUrl}/match/${outletKey}/?_rt=${rt}&tmcl=${tournamentCalendarId}&_pgNm=${page}&_pgSz=${limit}&_fmt=json`,
}

/**
 * in ms (should be smaller than any fetch frequencies)
 */
export const FETCH_TIMEOUT = {
    matchDetails: 3_000,
}

/**
 * in ms (should be greater than any fetch timeouts)
 */
export const FETCH_FREQUENCY = {
    liveMatch: 10_000,
    upcomingMatch: 120_000,
    nonLiveMatch: 30 * 60 * 1000,
} as const satisfies Record<string, number>

export const UPCOMING_THRESHOLD_IN_MINUTES = {
    lower: 3,
    upper: 30,
}

export const STATUS_LABEL: Record<MatchStatus, string> = {
    Awarded: 'Interrompu',
    Fixture: 'Prévu',
    Played: 'Terminé',
    Playing: 'En cours',
    Cancelled: 'Annulé',
    Postponed: 'Reporté',
    Suspended: 'Interrompu',
}

export type FetchFrequencyType = keyof typeof FETCH_FREQUENCY
